import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FormClient {
  private formUrl = environment.projektApiUrl + '/form';

  constructor(private http: HttpClient) {}

  public getLatestPublication(
    formId: string,
  ): Observable<{ publicationJson: string }> {
    const url = `${this.formUrl}/${formId}/latest-publication`;

    return this.http.get<{ publicationJson: string }>(url);
  }
}
